import { FunctionComponent, ReactElement } from "react";
import { useTranslation } from "react-i18next";

interface HeaderProps {
  className?: string;
  actions?: ReactElement;
}

const Header: FunctionComponent<HeaderProps> = ({
  className = "",
  actions,
}) => {
  const { t } = useTranslation();

  return (
    <header
      className={`d-flex align-items-center justify-content-between ${className}`}
    >
      <h3 className={`header-title ${actions ? "d-none d-md-block" : null}`}>
        {t("header.title")}
      </h3>
      {actions ? (
        actions
      ) : (
        <span className="header-description text-sm">
          {t("header.description")}
        </span>
      )}
    </header>
  );
};

export default Header;
